<video
  #videoElement
  class="own-video"
  (click)="playVideoWithoutControls(videoElement)"
  [ngStyle]="{
      'object-fit': objectFit,
      'object-position': objectPosition
    }"
  [controls]="controls"
  [src]="source"
  [attr.aria-label]="ariaLabel || null"
  [loop]="loop"
  [lazyPoster]="poster"
  [muted]="muted"
  [autoplay]="autoPlay"
  playsinline
>
  <source [src]="source" />
</video>
